import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import { container } from "../lib/style";

const styles = () => ({
  container: {
    ...container,
    zIndex: "2",
  },
  text: {
    textAlign: "center",
  },
});

const useStyles = makeStyles(styles);

const BigMessage = ({ title, subtitle, children }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Typography variant="h1" className={classes.text}>
        {title}
      </Typography>
      {subtitle ? (
        <Typography variant="h3" className={classes.text}>
          {subtitle}
        </Typography>
      ) : null}
      {children}
    </div>
  );
};

export default BigMessage;
